import React from "react";
import { render } from "storyblok-rich-text-react-renderer";

const RichTextBlock = ({ blok, isLast }) => {
  return <div className={`rich-text ${isLast ? `last` : ``}`}>{render(blok.copy)}</div>;
};

export default RichTextBlock;
